import CultureLabel from "components/Culture/CultureLabel";
import CulturesTemplateDropdown from "components/dropdowns/reactselect/CulturesTemplateDropdown";
import { WordTemplateForListViewFilePanel } from "components/FileUpload/SingleFilePanel";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { RenderEditOptions } from "components/MainSectionTemplate/types";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React, { useState } from "react";
import { WordTemplateForListViewInfo } from "./models";

interface WordTemplateForListViewDetailSectionProps {
  wordTemplateForListView: server.dto.WordTemplateForListView
}

export const WordTemplateForListViewDetailSection = (props: WordTemplateForListViewDetailSectionProps) => {
  const [wordTemplateForListView, setWordTemplateForListView] = useState<WordTemplateForListViewInfo>({
    title: props.wordTemplateForListView.title,
    lcid: props.wordTemplateForListView.lcid,
  });

  const culture = serverReference.templateCultures.find((c) => c.lcid === wordTemplateForListView.lcid);

  const onValueChanged = (key: string, value: any) => {
    if (key === "title") {
      setWordTemplateForListView({ ...wordTemplateForListView, title: value });
    } else if (key === "lcid") {
      setWordTemplateForListView({ ...wordTemplateForListView, lcid: value });
    }
  }

  const getUpdateWordTemplateForListViewInstruction = (wt: WordTemplateForListViewInfo): server.dto.UpdateWordTemplateForListViewDetailsInstruction => ({
    wordTemplateForListViewId: props.wordTemplateForListView.wordTemplateForListViewId,
    culture: wt.lcid,
    title: wt.title,
  });

  return <DetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    sections={[{
      type: "regular",
      key: "wordTemplateForListView",
      title: RESX.Template.DocumentTemplateForListView,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        render: () => <div>{wordTemplateForListView.title}</div>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<string>) => <RequiredTextInput
            validatorKey="title"
            focusOnMount
            maxLength={serverReference.constants.wordTemplate.maxTitleLength}
            value={value}
            onChange={(title) => { onChange(title); }}
            onEnter={() => submit()}
            onEsc={() => cancel()}
          />,
          fullWidth: true,
          type: "confirmOrCancelButton",
          initialValue: wordTemplateForListView.title,
          submitChange: (title: string) => window.CoreApi.WordTemplateForListView.UpdateDetails({
            ...getUpdateWordTemplateForListViewInstruction(wordTemplateForListView),
            title,
          }),
        },
      }, {
        key: "lcid",
        label: RESX.Language.resxLanguage,
        render: () => <CultureLabel culture={culture} />,
        inPageEdit: {
          render: ({ value, onChange, cancel }: RenderEditOptions<server.dto.LCID>) => <CulturesTemplateDropdown
            value={value}
            onChange={(c) => {
              onChange(c, true);
            }}
            onEsc={() => cancel()}
            config={{
              focusOnMount: true,
              openMenuOnFocus: true,
            }}
          />,
          fullWidth: true,
          type: "custom",
          initialValue: wordTemplateForListView.lcid,
          submitChange: (lcid: server.dto.LCID) => window.CoreApi.WordTemplateForListView.UpdateDetails({
            ...getUpdateWordTemplateForListViewInstruction(wordTemplateForListView),
            culture: lcid,
          })
        },
      }]
    }, {
      key: "file",
      type: "custom",
      render: () => <WordTemplateForListViewFilePanel
        key="files-panel"
        title={wordTemplateForListView.title}
        wordTemplateForListViewId={props.wordTemplateForListView.wordTemplateForListViewId}
        onUploadComplete={() => { }}
      />
    }]}
  />
}